import { Decarbonisation as DecarbonisationReport } from "@idwal/idwal-react-components";
import { useQuery } from "react-query";
import DataRequest from "../../queries/DataRequest";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { showRequestErrorToast } from "../../services/ErrorService";
import { Loading } from "../loading/Loading";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export const Decarbonisation = () => {
    const { inspectionId } = useParams();
    const { user } = useAuthenticator((context) => [
        context.authStatus,
        context.user
    ]);
    const { t } = useTranslation("locale");

    if (!inspectionId) {
        showRequestErrorToast("summary (id)");
    }

    const { error, data, isLoading } = useQuery(["summary"], () =>
        DataRequest(inspectionId ?? "", "summary", user)
    );

    if (isLoading || data == undefined) return <Loading />;

    if (error) {
        showRequestErrorToast("Summary");
        return <div></div>;
    }

    const { ciiData, eexiData } = data;

    if (!ciiData && !eexiData) {
        return (
            <div
                className="flex justify-content-center align-items-center h-3rem"
                style={{ backgroundColor: "#FCFCFC" }}
            >
                {t("decarbonisation.no_decarbonisation")}
            </div>
        );
    }

    return <DecarbonisationReport ciiData={ciiData} eexiData={eexiData} paragraph={data?.decarbonisation} />;
};
